import { atom } from "recoil";

export const IdSelectTourState = atom({
  key: "IdSelectTourState",
  default: undefined,
});
